import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import ThemeProvider from './context/ThemeProvider';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Products from './pages/Products/Products';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import About from './pages/About/About';
import Vision from './pages/Vision/Vision';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import './App.css';

// Lazy load Admin to keep main bundle small and secure-ish
const LazyAdmin = React.lazy(() => import('./pages/Admin/Admin'));

//edit-admin-PR

function App() {
  return (
    <DataProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <ErrorBoundary>
            <div className="App">
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:productId" element={<ProductDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/vision" element={<Vision />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                {process.env.REACT_APP_ENABLE_ADMIN === 'true' && (
                  <Route path="/admin" element={
                    <React.Suspense fallback={<div>Loading Admin...</div>}>
                      <LazyAdmin />
                    </React.Suspense>
                  } />
                )}
              </Routes>
              <Footer />
            </div>
          </ErrorBoundary>
        </Router>
      </ThemeProvider>
    </DataProvider>
  );
}

export default App;
